import { FC } from "react";
import { InputProps } from "./InputProps";
import { TextArea, TextInput, TEXT_INPUT_SIZE } from "./TextFields";
import { CheckBoxSet } from "./Checkboxes";
import { Dropdown } from "./Dropdown";
import { RadioSet } from "./Radio";
export const InputWrapper: FC<{
  inputProps: InputProps;
  placeHolder?: string;
  pattern?: string;
  checkValidation?: boolean;
  name: string;
  handleChange: Function;
}> = ({
  inputProps,
  placeHolder,
  pattern,
  checkValidation,
  name,
  handleChange,
}) => {
  return (
    <div id={inputProps.id}>
      {(() => {
        switch (inputProps.controlType) {
          case "Text":
            return (
              <TextInput
                id={inputProps.id}
                label={inputProps.label}
                required={inputProps.required}
                checkValidation={checkValidation}
                type="text"
                name={inputProps.label}
                handleChange={handleChange}
              />
            );
          case "TextArea":
            return (
              <TextArea
                id={inputProps.id}
                label={inputProps.label}
                required={inputProps.required}
                checkValidation={checkValidation}
                span={TEXT_INPUT_SIZE.full}
                name={inputProps.label}
                handleChange={handleChange}
              />
            );
          case "Select":
            return (
              <Dropdown inputProps={inputProps} handleChange={handleChange} />
            );
          case "Radio":
            return (
              <RadioSet inputProps={inputProps} handleChange={handleChange} />
            );
          case "Checkbox":
            return (
              <CheckBoxSet
                inputProps={inputProps}
                handleChange={handleChange}
              />
            );
          //   case "File":
          //     return <Error text={text} />;
          default:
            return null;
        }
      })()}
    </div>
  );
};
